<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <home-footer />
  </v-app>
</template>

<script>
export default {
  name: "PaymentWrapper",

  components: {
    HomeAppBar: () => import("@/views/pymt/layouts/PaymentAppBar.vue"),
    HomeFooter: () => import("@/views/pymt/layouts/Footer"),
    HomeView: () => import("@/views/pymt/layouts/View"),
  },
};
</script>